import educationHome from './education/home.jsx';
import educationProducts from './education/products.jsx';
import educationCourseDetail from './education/courseDetail.jsx';
import educationCart from './education/cart.jsx';
import educationSummary from './education/summary.jsx';
import educationAbout from './education/about.jsx';
import educationContact from './education/contact.jsx';
import educationBridgingKnowledgeGap from './education/bridgingKnowledgeGap.jsx';
import educationInsightsEngagement from './education/insightsEngagement.jsx';
import educationIndustryExperience from './education/industryExperience.jsx';
import educationGroomingSkills from './education/groomingSkills.jsx';
import educationSignIn from './education/signIn.jsx';
import educationSignUp from './education/signUp.jsx';
import retailHome from './retail/home.jsx';
import retailProducts from './retail/products.jsx';
import retailCategory from './retail/category.jsx';
import retailProductDetail from './retail/productDetail.jsx';
import retailCart from './retail/cart.jsx';
import retailSummary from './retail/summary.jsx';
import retailAbout from './retail/about.jsx';
import retailContact from './retail/contact.jsx';
import retailSignIn from './retail/signIn.jsx';
import retailSignUp from './retail/signUp.jsx';
import flexOfficeHome from './flexOffice/home.jsx';
import flexOfficeBookingHome from './flexOffice/bookingHome.jsx';
import flexOfficeServices from './flexOffice/services.jsx';
import flexOfficeServiceDetail from './flexOffice/serviceDetail.jsx';
import flexOfficeFeatures from './flexOffice/features.jsx';
import flexOfficeBookings from './flexOffice/bookings.jsx';
import flexOfficeInvoice from './flexOffice/invoice.jsx';
import flexOfficeContact from './flexOffice/contact.jsx';
import flexOfficeSignIn from './flexOffice/signIn.jsx';
import flexOfficeSignUp from './flexOffice/signUp.jsx';
import waasHome from './waas/home.jsx';
import waasAbout from './waas/about.jsx';
import waasServices from './waas/services.jsx';
import waasServer from './waas/server.jsx';
import waasCareer from './waas/career.jsx';
import waasContact from './waas/contact.jsx';
import waasSignIn from './waas/signIn.jsx';
import waasSignUp from './waas/signUp.jsx';
import { createPageReader } from './createPageReader.jsx';
import { normalizeTemplateDomain } from '../TemplateTheme.jsx';

const educationAboutAcademy = createPageReader('EDUCATION', 'aboutAcademy');
const flexOfficeBookSpace = createPageReader('FLEX_OFFICE', 'bookSpace');
const flexOfficeSpaceTypes = createPageReader('FLEX_OFFICE', 'spaceTypes');
const flexOfficeExploreLocations = createPageReader('FLEX_OFFICE', 'exploreLocations');
const flexOfficeBookSchedule = createPageReader('FLEX_OFFICE', 'bookSchedule');
const flexOfficeChoice = createPageReader('FLEX_OFFICE', 'choice');
const flexOfficeViewService = createPageReader('FLEX_OFFICE', 'viewService');
const flexOfficeMarketingFeatures = createPageReader('FLEX_OFFICE', 'marketingFeatures');
const flexOfficeConfirmBook = createPageReader('FLEX_OFFICE', 'confirmBook');
const flexOfficeReviewSchedule = createPageReader('FLEX_OFFICE', 'reviewSchedule');
const flexOfficeOrders = createPageReader('FLEX_OFFICE', 'orders');
const flexOfficeCustomerOrders = createPageReader('FLEX_OFFICE', 'customerOrders');
const flexOfficeUserCustomerOrders = createPageReader('FLEX_OFFICE', 'userCustomerOrders');
const flexOfficeInvoiceDetail = createPageReader('FLEX_OFFICE', 'invoiceDetail');
const flexOfficeAboutFlexOffice = createPageReader('FLEX_OFFICE', 'aboutFlexOffice');

export const templatePageReaders = {
  EDUCATION: {
    home: educationHome,
    products: educationProducts,
    courseDetail: educationCourseDetail,
    cart: educationCart,
    summary: educationSummary,
    about: educationAbout,
    aboutAcademy: educationAboutAcademy,
    contact: educationContact,
    bridgingKnowledgeGap: educationBridgingKnowledgeGap,
    insightsEngagement: educationInsightsEngagement,
    industryExperience: educationIndustryExperience,
    groomingSkills: educationGroomingSkills,
    signIn: educationSignIn,
    signUp: educationSignUp
  },
  RETAIL: {
    home: retailHome,
    products: retailProducts,
    category: retailCategory,
    productDetail: retailProductDetail,
    cart: retailCart,
    summary: retailSummary,
    about: retailAbout,
    contact: retailContact,
    signIn: retailSignIn,
    signUp: retailSignUp
  },
  FLEX_OFFICE: {
    home: flexOfficeHome,
    bookingHome: flexOfficeBookingHome,
    bookSpace: flexOfficeBookSpace,
    spaceTypes: flexOfficeSpaceTypes,
    exploreLocations: flexOfficeExploreLocations,
    bookSchedule: flexOfficeBookSchedule,
    choice: flexOfficeChoice,
    viewService: flexOfficeViewService,
    services: flexOfficeServices,
    serviceDetail: flexOfficeServiceDetail,
    features: flexOfficeFeatures,
    marketingFeatures: flexOfficeMarketingFeatures,
    confirmBook: flexOfficeConfirmBook,
    reviewSchedule: flexOfficeReviewSchedule,
    bookings: flexOfficeBookings,
    orders: flexOfficeOrders,
    customerOrders: flexOfficeCustomerOrders,
    userCustomerOrders: flexOfficeUserCustomerOrders,
    invoice: flexOfficeInvoice,
    invoiceDetail: flexOfficeInvoiceDetail,
    aboutFlexOffice: flexOfficeAboutFlexOffice,
    contact: flexOfficeContact,
    signIn: flexOfficeSignIn,
    signUp: flexOfficeSignUp
  },
  WAAS: {
    home: waasHome,
    about: waasAbout,
    services: waasServices,
    server: waasServer,
    career: waasCareer,
    contact: waasContact,
    signIn: waasSignIn,
    signUp: waasSignUp
  }
};

export const getTemplatePageReader = (domainType, pageKey) => (
  templatePageReaders[normalizeTemplateDomain(domainType)]?.[pageKey] || null
);
